/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { PerformanceMobile } from '../model/performanceMobile';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PerformanceMobileService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get since inception performance for a given portfolio id
     * @param id id
     * @param forcedCalculation 
     * @param frequency 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInceptionPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PerformanceMobile>;
    public getInceptionPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PerformanceMobile>>;
    public getInceptionPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PerformanceMobile>>;
    public getInceptionPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getInceptionPerformance.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>frequency, 'frequency');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/wealthmanagement/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/inception-performance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PerformanceMobile>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get performance for a given portfolio id
     * @param id id
     * @param beginDate 
     * @param endDate 
     * @param forcedCalculation 
     * @param frequency 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPerformance(id: string, beginDate: string, endDate: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PerformanceMobile>;
    public getPerformance(id: string, beginDate: string, endDate: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PerformanceMobile>>;
    public getPerformance(id: string, beginDate: string, endDate: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PerformanceMobile>>;
    public getPerformance(id: string, beginDate: string, endDate: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPerformance.');
        }
        if (beginDate === null || beginDate === undefined) {
            throw new Error('Required parameter beginDate was null or undefined when calling getPerformance.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getPerformance.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beginDate, 'beginDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDate, 'endDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>frequency, 'frequency');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/wealthmanagement/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/performance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PerformanceMobile>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get previous year performance for a given portfolio id
     * @param id id
     * @param forcedCalculation 
     * @param frequency 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPreviousYearPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PerformanceMobile>;
    public getPreviousYearPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PerformanceMobile>>;
    public getPreviousYearPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PerformanceMobile>>;
    public getPreviousYearPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPreviousYearPerformance.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>frequency, 'frequency');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/wealthmanagement/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/previous-year-performance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PerformanceMobile>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get year to date performance for a given portfolio id
     * @param id id
     * @param forcedCalculation 
     * @param frequency 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getYtdPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PerformanceMobile>;
    public getYtdPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PerformanceMobile>>;
    public getYtdPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PerformanceMobile>>;
    public getYtdPerformance(id: string, forcedCalculation?: boolean, frequency?: 'ON_DEMAND' | 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'BIANNUAL' | 'ANNUAL' | 'WEEKLY' | 'FORTNIGHTLY' | 'BIMONTHLY' | 'DAILY_BUSINESS' | 'TAX_PERIOD' | 'BIWEEKLY' | 'EVERY_TWO_YEARS' | 'EVERY_THREE_YEARS' | 'EVERY_FOUR_YEARS' | 'EVERY_FIVE_YEARS' | 'DO_NOT_UPDATE' | 'EVERY_FOUR_MONTH' | 'EVERY_SIX_YEARS' | 'QUARTERLY_MONTH2TO4' | 'QUARTERLY_MONTH3TO5' | 'AT_MATURITY', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getYtdPerformance.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>frequency, 'frequency');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/wealthmanagement/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/current-year-performance`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PerformanceMobile>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
